<template>
    <pre class="mb-0 language-json code-toolbar" :style="{overflow: 'auto', height: height}"><code class="language-json" v-html="formattedCode"></code></pre>
</template>
<script>
import Prism from 'prismjs';
import 'prismjs/components/prism-json';
export default {
    name: "CodeViewer",
    props: {
        modelValue: {
            type: Object,
            default: ''
        },
        height: {
            type: String,
            default: '100%'
        }
    },
    computed: {
        formattedCode() {
            const jsonString = JSON.stringify(this.modelValue, null, 2);
            return Prism.highlight(jsonString, Prism.languages.json, 'json');
        }
    }
}
</script>
<style scoped>
code {
    padding: 0;
}
</style>